import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Snackbar,
  FormLabel,
  Divider,
  FormControl,
  InputLabel,
  Autocomplete,
  Typography,
  autocompleteClasses,
  InputAdornment,
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextareaAutosize,
  Menu,
  IconButton,
} from "@mui/material";
import omit from "lodash/omit";

import isEqual from "lodash/isEqual";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  themeStyles,
  buttonStyle,
  SESSION_NOTE_97153,
  DATA_ENTRY_PAGE,
  CREATE,
  API_BASE_URL,
  SESSION_PARTICIPANTS_MAPPING,
  RBT_WORK_STYLE_MAPPING,
  SKILL_STRATEGIES_MAPPING,
  BEHAVIOR_STRATEGIES_MAPPING,
  UPDATE,
  SESSION_ID,
  DELETE,
  VIEW_SESSION_NOTE,
} from "../../../constants";
import { cleanText } from "../../../utils/textUtils";
import "./index.css";
import { Alert } from "@mui/material";
import { tokens } from "../../../theme";
import SignaturePad from "react-signature-canvas";
import { MultiInputTimeRangeField } from "@mui/x-date-pickers-pro";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axiosInstance from "../../../components/AxiosInstance";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useState, useEffect, useRef } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Formik, Field } from "formik";
import SampleModal from "../../SamplePdFModal";
import dayjs from "dayjs";
import * as yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import LoadingIndicator from "../../Loader";
import { formatDate } from "@fullcalendar/core";
import { useTheme } from "@emotion/react";
import useSharedLink from "../../SharedLink";
import { useAutoSave } from "../../../utils/AutoSave";
import { usePermissions } from "../../../Phase3/CheckPermission";
import { useSnackbar } from "../../../components/SnackBarProvider";
import { checkOwner } from "../SessionNoteCommon/ownerChecking";
const SessionNote = ({ mode }) => {
  const location = useLocation();
  const {
    checkPermission,
    giveClients,
    giveStaff,
    checkApprover,
    fetchSupervisor,
    checkStaffPermission,
  } = usePermissions();
  const [canApprove, setCanApprove] = useState(false);
  const { openSnackbar } = useSnackbar();
  const queryParams = new URLSearchParams(location.search);
  const clientId = queryParams.get("clientid");
  const date = queryParams.get("date");
  const sessionId = queryParams.get("sessionId");
  const navigate = useNavigate();
  const theme = useTheme();
  const sharedLink = useSharedLink();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [facilities, setFacilities] = useState([]);
  const clients = giveClients(SESSION_NOTE_97153, mode);
  const client = clientId
    ? (clients || []).find(
        (client) => parseFloat(client.id) === parseFloat(clientId)
      )
    : null;
  const staffs = giveStaff(SESSION_NOTE_97153, mode);
  const [supervisor, setSupervisor] = useState([]);
  const [previouspagevalues, setPreviousPageValues] = useState(
    location.state?.previouspagevalues
  );

  const [formValues, setFormValues] = useState({});
  const from = location.state?.from;
  const [selectedSupervisors, setSelectedSupervisors] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [initialValues, setInitialValues] = useState({});
  const [staffSignatureImage, setStaffSignatureImage] = useState({
    image: null,
    date: null,
    exists: false,
  });
  const [parentSignatureImage, setParentSignatureImage] = useState({
    image: null,
    date: null,
    exists: false,
  });
  const [supervisorSignatureImage, setSupervisorSignatureImage] = useState({
    image: null,
    date: null,
    exists: false,
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const latestFormValues = useRef({});
  console.log("isdisabled", isDisabled);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const handleCloseImageModal = () => setIsImageModalOpen(false);

  const [isFormDirty, setIsFormDirty] = useState(false); // Flag to track form changes
  const [showLeaveAlert, setShowLeaveAlert] = useState(false); // Flag to show custom leave alert
  const [isSignaturePresent, setIsSignaturePresent] = useState(false);

  const sessionType = ["Adaptive Behaviour Treatment", "Other"];
  const placeOfService = ["Home", "School", "Other"];
  const diagnosisCode = ["F84.0", "Other"];
  const procedureCode = ["97151", "97153", "97156", "97155", "Other"];
  const moDifier = ["HM", "HN", "HO", "Other"];
  const parentOrGurdian = ["Parent", "Gurdian", "Other"];

  const [sessionparticipantsState, setSessionParticipants] = useState({
    child: true,
    parent: true,
    bcba: false,
    behaviourtechnician: true,
    other: false,
  });

  const [rbtworkstyleState, setRbtWorkStyle] = useState({
    optiona: false,
    optionb: false,
    otherrbt: false,
  });

  const [skillStratergiesState, setSkillStratergies] = useState({
    roleplaying: false,
    discretetrialtraining: false,
    behaviourmomentum: false,
    generalizationtraining: false,
    shapingchaining: false,
    naturalenvironmentteaching: false,
    providingsupport: false,
    na: false,
    otherskill: false,
  });

  const [behaviorStratergiesState, setBehaviorStratergies] = useState({
    modeling: false,
    guidedcompliance: false,
    differntialreinforcement: false,
    verbalremindersprovided: false,
    firststatements: false,
    contigentrewards: false,
    visualsupports: false,
    nabehavior: false,
    otherbehavior: false,
  });

  const {
    modeling,
    guidedcompliance,
    differntialreinforcement,
    verbalremindersprovided,
    firststatements,
    contigentrewards,
    visualsupports,
    nabehavior,
    otherbehavior,
  } = behaviorStratergiesState;

  const { child, parent, bcba, behaviourtechnician, other } =
    sessionparticipantsState;

  const { optiona, optionb, otherrbt } = rbtworkstyleState;

  const {
    roleplaying,
    discretetrialtraining,
    behaviourmomentum,
    generalizationtraining,
    shapingchaining,
    naturalenvironmentteaching,
    providingsupport,

    na,
    otherskill,
  } = skillStratergiesState;
  const [modalSize, setModalSize] = useState("small");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState("");

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = (pdf) => {
    setSelectedPdf(pdf);
    // setModalSize(size);

    setIsModalOpen(true);

    handleMenuClose();
  };
  const handleImageModal = (pdf, size = "small") => {
    setSelectedPdf(pdf);
    setModalSize(size);
    setIsImageModalOpen(true);
  };

  const sigParent = useRef(null);
  const sigSupervisor = useRef(null);
  const sigStaff = useRef(null);
  const clearParentSignature = () => {
    sigParent.current.clear();
    setIsFormDirty(false); // Reset dirty state when signature is cleared
  };
  // useEffect(() => {
  //   latestFormValues.current = formValues;
  //   console.log("Updated latestFormValues.current:", latestFormValues.current);
  // }, [formValues]); // This will always trigger when `formValues` changes

  const clearSupervisorSignature = () => {
    if (
      sigSupervisor.current &&
      typeof sigSupervisor.current.clear === "function"
    ) {
      setIsSignaturePresent(false); // Mark signature as not present
      sigSupervisor.current.clear(); // Safely clear the signature pad
    } else {
      console.error("SignaturePad reference is invalid or not initialized.");
    }
  };
  const clearStaffSignature = () => {
    sigStaff.current.clear();
    setIsFormDirty(false); // Reset dirty state when signature is cleared
  };
  const updateCheckboxState = (event, stateUpdater, stateKey, mapper = {}) => {
    const { name, checked } = event.target;

    stateUpdater((prevState) => {
      const newState = { ...prevState, [name]: checked };

      latestFormValues.current = {
        ...latestFormValues.current,
        [stateKey]: Object.entries(newState)
          .filter(([_, value]) => value) // Only include checked items
          .map(([key]) => mapper?.[key] || key) // Fallback to key if mapper is undefined
          .join(";"),
      };
      setFormValues((prevValues) => ({
        ...prevValues,
        [stateKey]: Object.entries(newState)
          .filter(([_, value]) => value) // Only include checked items
          .map(([key]) => mapper?.[key] || key) // Fallback to key if mapper is undefined
          .join(";"),
      }));
      setIsFormDirty(Object.values(newState).some((value) => value));
      return newState;
    });
  };

  const updateStateFromData = (data, mapping, stateUpdater, stateKey) => {
    data?.forEach((element) => {
      const lowerCaseElement = element.toLowerCase().trim();

      // Find the corresponding checkbox key by matching the label
      const matchedKey = Object.keys(mapping).find(
        (key) => mapping[key].toLowerCase() === lowerCaseElement
      );

      if (matchedKey) {
        updateCheckboxState(
          {
            target: {
              name: matchedKey.replaceAll("_", "").toLowerCase(),
              checked: true,
            },
          },
          stateUpdater,
          stateKey.replaceAll("_", "").toLowerCase(),
          mapping
        );
      }
      console.log(matchedKey, "matchedkey");
    });
  };
  const getEndPoint = (payload) => {
    if (localStorage.getItem(SESSION_ID)) {
      payload.id = localStorage.getItem(SESSION_ID);

      return sharedLink + "/updatesessionnote";
    }
    return sharedLink + "/addsessionnote";
  };
  const handleInputChange = (event, setFieldValue) => {
    const cleanValue = cleanText(event.target.value);
    setFieldValue(event.target.name, cleanValue);
    handleFieldChange(cleanValue, event.target.name, initialValues);
  };

  const handleSupervisorSignature = () => {
    if (sigSupervisor.current.isEmpty()) {
      setIsSignaturePresent(false); // Mark signature as not present
    } else {
      setIsSignaturePresent(true); // Mark signature as present
    }
  };

  const handleStaffSignature = () => {
    if (sigStaff.current.isEmpty()) {
      setIsFormDirty(false); // Reset dirty state if signature is cleared
    } else {
      setIsFormDirty(true); // Mark form as dirty if signature is modified
    }
  };
  const handleParentSignature = () => {
    if (sigParent.current.isEmpty()) {
      setIsFormDirty(false); // Reset dirty state if signature is cleared
    } else {
      setIsFormDirty(true); // Mark form as dirty if signature is modified
    }
  };
  const handleDeleteSignature = async (signatureType) => {
    const isConfirmed = window.confirm(
      "Are you sure want to delete this signature? This action cannot be undone."
    );

    if (!isConfirmed) return; // Exit if user cancels

    try {
      // API call to delete the signature
      await axiosInstance.post(API_BASE_URL + "/api/deleteSignature", {
        signaturetype: signatureType,
        sessionnoteid: sessionId,
        procedurecode: "97153",
        // Assuming sessionId is available in the component
      });

      // Clear the respective signature image
      switch (signatureType) {
        case "Staff":
          setStaffSignatureImage({ image: null, date: null, exists: false });

          handleFieldChange(false, "staffsignatureexist", initialValues);
          handleFieldChange(null, "staffsignaturefilename", initialValues);
          handleFieldChange(null, "staffsignaturedate", initialValues);

          break;
        case "Parent":
          setParentSignatureImage({ image: null, date: null, exists: false });
          handleFieldChange(false, "parentsignatureexist", initialValues);
          handleFieldChange(
            null,
            "parentorgurdiansignaturefilename",
            initialValues
          );
          handleFieldChange(
            null,
            "parentorgurdiansignaturedate",
            initialValues
          );
          break;
        case "Supervisor":
          setSupervisorSignatureImage({
            image: null,
            date: null,
            exists: false,
          });
          handleFieldChange(false, "supervisorsignatureexist", initialValues);
          handleFieldChange(null, "supervisorsignaturefilename", initialValues);
          handleFieldChange(null, "supervisorsignaturedate", initialValues);

          break;
        default:
          break;
      }
      handleFieldChange("Draft", "sessionstatus", initialValues);
      openSnackbar("Signature deleted successfully", "success");
    } catch (error) {
      openSnackbar(error, "error");
      console.error("Error deleting signature:", error);
    }
  };

  useEffect(() => {
    console.log("changed values in 97153", initialValues);
    // Warn user before leaving the page if there are unsaved changes
    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault();
        event.returnValue = ""; // Required for showing the browser prompt
      }
    };

    // Add event listener for browser back navigation
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [initialValues]);

  useEffect(() => {
    const initializeSessionAndFetchData = async () => {
      try {
        setIsloading(true);

        // Clear any existing session ID from localStorage
        const savedSessionId = localStorage.getItem(SESSION_ID);
        if (savedSessionId) {
          localStorage.removeItem(SESSION_ID);
          localStorage.removeItem("lastSavedData");
        }

        console.log(mode, "mode");

        // If the mode is UPDATE, store session ID and fetch initial values
        if (mode === UPDATE) {
          localStorage.setItem(SESSION_ID, sessionId);
          await fetchInitialValues();
        } else await fetchData();

        setIsloading(false);
      } catch (error) {
        console.error("Error initializing session and fetching data:", error);
        setIsloading(false);
      }
    };

    initializeSessionAndFetchData();
  }, [isDisabled]);

  const handleFieldChange = (newValue, fieldName, values) => {
    console.log();
    setFormValues((prevValues) => ({
      ...prevValues,
      [fieldName]: newValue,
    }));
    latestFormValues.current = {
      ...latestFormValues.current,
      [fieldName]: newValue,
    }; // Ensure ref is updated immediately
    console.log("current values", {
      ...latestFormValues.current,
    });
  };

  // Handle custom back button navigation

  const handleGoBack = async () => {
    const latestValues = JSON.parse(JSON.stringify(latestFormValues.current));
    const lastSavedData = await JSON.parse(
      await localStorage.getItem("lastSavedData")
    );

    // Fields to omit during comparison
    const fieldsToOmit = [
      "parentorgurdiansignaturefilename",
      "staffsignaturefilename",
      "supervisorsignaturefilename",
    ];

    // Remove the fields from both objects
    const filteredLatestValues = omit(latestValues, fieldsToOmit);
    const filteredLastSavedData = omit(lastSavedData, fieldsToOmit);
    console.log(
      JSON.stringify(filteredLatestValues) ===
        JSON.stringify(filteredLastSavedData),
      "checking value",
      isEqual(filteredLatestValues, filteredLastSavedData)
    );
    let flag = true;
    Object.keys(filteredLatestValues).forEach((key) => {
      if (filteredLatestValues[key] !== filteredLastSavedData[key]) {
        flag = false;
        console.log(
          `Mismatch at key "${key}":`,
          filteredLatestValues[key],
          filteredLastSavedData[key]
        );
      }
    });
    console.log(filteredLatestValues, "LATEST VALUES (filtered)");
    console.log(filteredLastSavedData, "LAST SAVED DATA (filtered)");

    if (!flag) {
      setShowLeaveAlert(true); // Show con // Show confirmation dialog if there are unsaved changes
    } else {
      const stateToSave = {
        formValues: previouspagevalues?.formValues,
        rows: previouspagevalues?.rows,
        staffs: previouspagevalues?.staffs,
        clients: previouspagevalues?.clients,
      };
      console.log(from + "from");
      console.log(stateToSave, "edit");
      if (from == VIEW_SESSION_NOTE)
        navigate("/viewsessionnotes", {
          state: { previouspagevalues: stateToSave },
        });
      else navigate(-1);
    }
  };

  // Handle user response to the leave alert
  const handleLeaveAlertResponse = (leave) => {
    setShowLeaveAlert(false); // Close the alert
    if (leave) {
      const stateToSave = {
        formValues: previouspagevalues?.formValues,
        rows: previouspagevalues?.rows,
        staffs: previouspagevalues?.staffs,
        clients: previouspagevalues?.clients,
      };
      console.log(from + "from");
      console.log(stateToSave, "edit");
      if (from == VIEW_SESSION_NOTE)
        navigate("/viewsessionnotes", {
          state: { previouspagevalues: stateToSave },
        });
      else navigate(-1);
    }
  };
  const fetchInitialValues = async () => {
    try {
      const userRole = localStorage.getItem("role");
      const [sessiondata, supervisorResponse, facilitiesResponse] =
        await Promise.all([
          axiosInstance.post(
            sharedLink + "/viewasessionnote",
            { id: sessionId, procedurecode: "97153" },
            { withCredentials: true }
          ),
          axiosInstance.post(
            sharedLink + "/roles/supervisorofrole",
            { role: userRole },
            { withCredentials: true }
          ),
          axiosInstance.post(sharedLink + "/viewallfacility", {
            withCredentials: true,
          }),
        ]);
      const session = sessiondata.data[0];
      fetchEligibleSupervisors(session.staffId);

      const payload = {
        facilityid: {
          id: session.facilityId,
          facilityName: session.facilityName,
        },
        clientid: {
          id: session.clientId,
          firstName: session.clientFirstName,
          lastName: session.clientLastName,
        },
        staffid: {
          id: session.staffId,
          firstName: session.staffFirstName,
          lastName: session.staffLastName,
        },
        supervisorid: {
          id: session.supervisorId,
          firstName: session.supervisorFirstName,
          lastName: session.supervisorLastName,
        },
        insurancename: session.insuranceName,
        insurancepolicynumber: session.insurancePolicyNumber,

        parentorgurdianname: session.parentOrGurdianName,

        sessiontype: session.sessionType,

        sessiondate: dayjs(session.sessionDate),
        placeofservicecode: session.placeOfServiceCode,
        otherplaceofservice: session.otherPlaceOfService,
        modifier: session.modifier,
        procedurecode: session.procedureCode,

        diagnosiscode1: session.diagnosisCode1,

        otherdiagnosiscode: session.otherDiagnosisCode,
        primarytargetareasaddressed: session.primaryTargetAreasAddressed,
        reinforcerusedduringsession: session.reinforcerUsedDuringSession,
        maladaptivebehaviors: session.malAdaptiveBehaviors,
        sessionid: session.sessionId,
        otherskillstrategiesapplied: session.otherskillStrategiesApplied,
        othersessionparticipants: session.otherSessionParticipants,
        otherrbtworkstyle: session.otherrbtWorkStyle,
        otherbehaviorstrategiesapplied: session.otherBehaviorStrategiesApplied,
        clientmoodresponse: session.clientMoodResponse,
        sessionsummary: session.sessionSummary,
        planfornextvisit: session.planForNextVisit,
        sessionstatus: session.sessionStatus,
      };
      setIsDisabled(
        checkPermission(
          SESSION_NOTE_97153,
          UPDATE,
          checkOwner({ staffid: { id: session.staffId } })
        ) == false
      );
      if (session.parentOrGurdianSignatureFileName) {
        const dataURLParent = `data:image/png;base64,${session.parentOrGurdianSignatureFileName}`;
        setParentSignatureImage({
          image: dataURLParent,
          date: dayjs(session.parentOrGurdianSignatureDate),
          exists: true,
        });
      }
      if (session.staffSignatureFileName) {
        const dataURLStaff = `data:image/png;base64,${session.staffSignatureFileName}`;
        setStaffSignatureImage({
          image: dataURLStaff,
          date: dayjs(session.staffSignatureDate),
          exists: true,
        });
      }
      if (session.supervisorSignatureFileName) {
        const dataURLsupervisor = `data:image/png;base64,${session.supervisorSignatureFileName}`;
        setSupervisorSignatureImage({
          image: dataURLsupervisor,
          date: dayjs(session.supervisorsignaturedate),
          exists: true,
        });
      }

      try {
        const approval = await checkApprover(session.staffId);
        console.log("app", approval);
        setCanApprove(approval);
      } catch (error) {
        console.error("Error checking approver:", error);
        setCanApprove(false);
      }

      // Create a data URL. I'm assuming it's a PNG image here, but adjust the MIME type if it's different.

      const convert = (time12Hour) => {
        const [hour, minutePart] = time12Hour.split(":");
        const [minute, period] = minutePart.split(" ");

        let hour24 = parseInt(hour, 10);
        if (period === "PM" && hour24 !== 12) {
          hour24 += 12;
        } else if (period === "AM" && hour24 === 12) {
          hour24 = 0;
        }

        return `${String(hour24).padStart(2, "0")}:${minute}`;
      };

      const start = convert(session.sessionStartTime);
      const end = convert(session.sessionEndTime);

      // Construct the full datetime string without specifying a time zone
      const initialStartTime = moment(
        `Mon Oct 30 2023 ${start}:00`,
        "ddd MMM DD YYYY HH:mm:ss"
      );
      const initialEndTime = moment(
        `Mon Oct 30 2023 ${end}:00`,
        "ddd MMM DD YYYY HH:mm:ss"
      );

      updateStateFromData(
        session.sessionParticipants,
        SESSION_PARTICIPANTS_MAPPING,
        setSessionParticipants,
        "SESSION_PARTICIPANTS"
      );

      // Update skill strategies
      updateStateFromData(
        session.skillStrategiesApplied,
        SKILL_STRATEGIES_MAPPING,
        setSkillStratergies,
        "SKILL_STRATEGIES_APPLIED"
      );

      // Update RBT work style
      updateStateFromData(
        session.rbtWorkStyle,
        RBT_WORK_STYLE_MAPPING,
        setRbtWorkStyle,
        "RBT_WORK_STYLE"
      );

      // Update behavior strategies
      updateStateFromData(
        session.behaviorStrategiesApplied,
        BEHAVIOR_STRATEGIES_MAPPING,
        setBehaviorStratergies,
        "BEHAVIOR_STRATEGIES_APPLIED"
      );

      setSupervisor(supervisorResponse.data);
      setFacilities(facilitiesResponse.data);
      setInitialValues(payload);
      latestFormValues.current = {
        ...payload,
        staffid: session.staffId,
        clientid: session.clientId,
        supervisorid: session.supervisorId,
        facilityid: session.facilityId,
        sessiondate: session.sessionDate,
        sessionstarttime: session.sessionStartTime,
        sessionendtime: session.sessionEndTime,
        parentorgurdiansignaturefilename:
          session.parentOrGurdianSignatureFileName,
        supervisorsignaturefilename: session.supervisorSignatureFileName,
        supervisorsignaturedate: session.supervisorSignatureDate,
        supervisorsignatureexist: session.supervisorSignatureExist,
        staffsignaturefilename: session.staffSignatureFileName,
        staffsignaturedate: session.staffSignatureDate,
        staffsignatureexist: session.staffSignatureExist,
        parentorgurdiansignaturedate: session.parentOrGurdianSignatureDate,
        parentorguardiansignatureexist: session.parentSignatureExist,
      };
      await localStorage.setItem(
        "lastSavedData",
        JSON.stringify({
          ...payload,
          id: sessionId,
          staffid: session.staffId,
          clientid: session.clientId,
          supervisorid: session.supervisorId,
          facilityid: session.facilityId,
          sessiondate: session.sessionDate,
          sessionstarttime: session.sessionStartTime,
          sessionendtime: session.sessionEndTime,
          parentorgurdiansignaturefilename:
            session.parentOrGurdianSignatureFileName,
          supervisorsignaturefilename: session.supervisorSignatureFileName,
          supervisorsignaturedate: session.supervisorSignatureDate,
          supervisorsignatureexist: session.supervisorSignatureExist,
          staffsignaturefilename: session.staffSignatureFileName,
          staffsignaturedate: session.staffSignatureDate,
          staffsignatureexist: session.staffSignatureExist,
          parentorgurdiansignaturedate: session.parentOrGurdianSignatureDate,
          parentorguardiansignatureexist: session.parentSignatureExist,
          sessionparticipants: (session.sessionParticipants || []).join(";"),
          behaviorstrategiesapplied: (
            session.behaviorStrategiesApplied || []
          ).join(";"),
          rbtworkstyle: (session.rbtWorkStyle || []).join(";"),
          skillstrategiesapplied: (session.skillStrategiesApplied || []).join(
            ";"
          ),
        })
      );
      payload.sessiontime = [initialStartTime, initialEndTime];

      console.log("latestvalues.current", latestFormValues.current, {
        ...payload,
        staffid: session.staffId,
        clientid: session.clientId,
        supervisorid: session.supervisorId,
        facilityid: session.facilityId,
        sessiondate: session.sessionDate,
        sessionStartTime: session.sessionStartTime,
        sessionEndTime: session.sessionEndTime,
        parentorgurdiansignaturefilename:
          session.parentOrGurdianSignatureFileName,
        supervisorsignaturefilename: session.supervisorSignatureFileName,
        supervisorsignaturedate: session.supervisorSignatureDate,
        supervisorsignatureexist: session.supervisorSignatureExist,
        staffsignaturefilename: session.staffSignatureFileName,
        staffsignaturedate: session.staffSignatureDate,
        staffsignatureexist: session.staffSignatureExist,
        parentorgurdiansignaturedate: session.parentOrGurdianSignatureDate,
        parentorguardiansignatureexist: session.parentOrGuardianSignatureExist,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDisabling = (values) => {
    if (mode == UPDATE) {
      return (
        checkPermission(
          SESSION_NOTE_97153,
          mode,
          checkOwner({ staffid: values.staffid })
        ) == false
      );
    }
    return false;
  };
  const fetchData = async () => {
    const maxRetries = 5; // Define a maximum number of retries to avoid infinite loops
    const retryDelay = 2000; // Delay between retries, in milliseconds (e.g., 2 seconds)
    const userRole = localStorage.getItem("role");
    try {
      const [supervisorResponse, facilitiesResponse] = await Promise.all([
        axiosInstance.post(
          sharedLink + "/roles/supervisorofrole",
          { role: userRole },
          { withCredentials: true }
        ),
        axiosInstance.post(sharedLink + "/viewallfacility", {
          withCredentials: true,
        }),
      ]);

      setSupervisor(supervisorResponse.data);
      setFacilities(facilitiesResponse.data);
      console.log(client, "in session note");
      const initialValues = {
        facilityid: null,
        clientid: clientId
          ? {
              id: clientId ? clientId : "",
              firstName: location.state?.clientName,
              lastName: "",
            }
          : null,
        insurancename: client?.insuranceName,
        insurancepolicynumber: client?.policyNumber,
        staffid: {
          id: localStorage.getItem("userId"),
          firstName: localStorage.getItem("username"),
          lastName: "",
        },
        supervisorid: null,
        sessiondate: date ? dayjs(date) : dayjs(), // Default session date to today
        sessionstarttime: null,
        sessionendtime: "",
        sessiontype: "Adaptive Behaviour Treatment",
        placeofservicecode: "Home",
        otherplaceofservice: "",
        modifier: "HN",
        diagnosiscode1: "F84.0",
        otherdiagnosiscode: "",
        procedurecode: "97153",
        sessionparticipants: "",
        othersessionparticipants: "",
        rbtworkstyle: "",
        otherrbtworkstyle: "",
        skillstrategiesapplied: "",
        otherskillstrategiesapplied: "",
        behaviorstrategiesapplied: "",
        otherbehaviorstrategiesapplied: "",
        maladaptivebehaviors: "",
        reinforcerusedduringsession: "",
        primarytargetareasaddressed: "",
        sessionsummary: "",
        clientmoodresponse: "",
        planfornextvisit: "",
        otherrbtworkstyle: "",
        parentorgurdianname: "Parent",
        parentorgurdiansignaturefilename: "",
        parentorgurdiansignaturedate: null,
        staffsignaturefilename: "",
        staffsignaturedate: null,
        supervisorsignaturefilename: "",
        supervisorsignaturedate: null,
        sessionstatus: "Draft",
        parentsignatureexist: false,
        staffsignatureexist: false,
        supervisorsignatureexist: false,
      };
      fetchEligibleSupervisors(localStorage.getItem("userId"));
      setInitialValues(initialValues);
      latestFormValues.current = {
        ...initialValues,
        staffid: initialValues.staffid.id,
        sessiondate: dayjs().format("YYYY-MM-DD"),
      };
      await localStorage.setItem(
        "lastSavedData",
        JSON.stringify({
          ...initialValues,
          staffid: initialValues.staffid.id,
          sessiondate: dayjs().format("YYYY-MM-DD"),
        })
      );
    } catch (error) {
      openSnackbar("Failed to fetch data after multiple attempts.", "error");
    }
  };

  useEffect(() => {}, [isloading]);
  const handleData = (formData) => {
    const formattedSessionDate = dayjs(formData.sessiondate).format(
      "YYYY-MM-DD"
    );

    var today = new Date();
    var currdate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1 < 10
        ? "0" + (today.getMonth() + 1)
        : today.getMonth() + 1) +
      "-" +
      (today.getDate() < 10 ? "0" + today.getDate() : today.getDate());

    console.log(currdate);

    var sessionpart =
      (child ? "Child;" : "") +
      (parent ? "Parent;" : "") +
      (bcba ? "BCBA;" : "") +
      (behaviourtechnician ? "Behaviour Technician;" : "") +
      (other ? "Other;" : "");

    console.log("sessionparticipants", sessionpart);

    if (sessionpart === "") {
      openSnackbar("Please select session participants", "error");
      return null;
    }

    var rbtwork =
      (optiona ? "RBT/BT worked on goals in treatment plan;" : "") +
      (optionb ? "RBT/BT worked on pairing with reinforcers;" : "") +
      (otherrbt ? "Other;" : "");
    if (rbtwork === "") {
      openSnackbar("Please select RBT work style", "error");
      return null;
    }

    var skillstratergies =
      (roleplaying ? "Role playing or modeling;" : "") +
      (discretetrialtraining ? "Discrete trial training;" : "") +
      (behaviourmomentum ? "Behavior Momentum;" : "") +
      (generalizationtraining ? "Generalization training;" : "") +
      (shapingchaining ? "Shaping/Chaining;" : "") +
      (naturalenvironmentteaching ? "Natural environment teaching;" : "") +
      (providingsupport ? "Providing support with prompt fading;" : "") +
      (na ? "N/A;" : "") +
      (otherskill ? "Other;" : "");

    if (skillstratergies === "") {
      openSnackbar("Please Choose Skill Stratergies", "error");
      return null;
    }

    var behaviorstratergies =
      (modeling ? "Modeling;" : "") +
      (guidedcompliance ? "Guided Compliance;" : "") +
      (differntialreinforcement ? "Differential Reinforcement;" : "") +
      (verbalremindersprovided ? "Verbal reminders provided;" : "") +
      (firststatements ? "First/Then statements;" : "") +
      (contigentrewards ? "Contingent rewards/reinforcers;" : "") +
      (visualsupports
        ? "Visual supports (timer, schedule, token board etc.);"
        : "") +
      (nabehavior ? "N/A;" : "") +
      (otherbehavior ? "Other;" : "");
    if (behaviorstratergies === "") {
      openSnackbar("Please Choose Behavior Stratergies", "error");
      return null;
    }
    if (otherbehavior) {
      if (formData.otherbehaviorstrategiesapplied === "") {
        openSnackbar(
          "Please fill in other behavior strategies applied",
          "error"
        );
        return null;
      }
    }
    if (otherskill) {
      if (formData.otherskillstrategiesapplied === "") {
        openSnackbar("Please fill in other skill strategies applied", "error");
        return null;
      }
    }
    if (otherrbt) {
      if (formData.otherrbtworkstyle === "") {
        openSnackbar("Please fill in other RBT work style", "error");
        return null;
      }
    }
    if (other) {
      if (formData.othersessionparticipants === "") {
        openSnackbar("Please fill in other session participants", "error");
        return null;
      }
    }

    const { sessiontime, ...otherValues } = formData;
    otherValues.parentorgurdiansignaturefilename = parentSignatureImage.image;
    otherValues.parentorgurdiansignaturedate = parentSignatureImage.date;
    otherValues.parentorguardiansignatureexist = parentSignatureImage.exists;
    otherValues.supervisorsignaturefilename = supervisorSignatureImage.image;
    otherValues.supervisorsignaturedate = supervisorSignatureImage.date;
    otherValues.supervisorsignatureexist = supervisorSignatureImage.exists;
    otherValues.staffsignatureexist = staffSignatureImage.exists;
    otherValues.staffsignaturefilename = staffSignatureImage.image;
    otherValues.staffsignaturedate = staffSignatureImage.date;
    if (canApprove) {
      if (sigSupervisor.current && !sigSupervisor.current?.isEmpty()) {
        otherValues.supervisorsignaturefilename = sigSupervisor.current
          .getTrimmedCanvas()
          .toDataURL("image/png");
        otherValues.supervisorsignaturedate = dayjs(
          formData.supervisorsignaturedate
        ).format("YYYY-MM-DD");
        otherValues.supervisorsignatureexist = false;
      }
    }

    if (sigParent.current && !sigParent?.current?.isEmpty()) {
      otherValues.parentorgurdiansignaturefilename = sigParent.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      otherValues.parentorgurdiansignaturedate = currdate;
      otherValues.parentorguardiansignatureexist = false;
    }
    if (sigStaff.current && !sigStaff.current.isEmpty()) {
      otherValues.staffsignaturefilename = sigStaff.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      otherValues.staffsignaturedate = currdate;
      otherValues.staffsignatureexist = false;
    }

    const payload = {
      ...otherValues,
      sessiondate: formattedSessionDate,
      sessionparticipants: sessionpart,
      rbtworkstyle: rbtwork,
      otherdiagnosiscode:
        formData.diagnosisCode1 === "Other" ? formData.otherdiagnosiscode : "",

      skillstrategiesapplied: skillstratergies,
      behaviorstrategiesapplied: behaviorstratergies,
      sessionendtime: formData.sessiontime[1].format("HH:mm:a"),
      sessionstarttime: formData.sessiontime[0].format("HH:mm:a"),
      enteredby: localStorage.getItem("username"),
    };
    console.log("sending", payload);

    return payload;
  };
  const handleErrors = (formData) => {
    console.log(formData, "formadta in handlerror");
    if (!formData.sessiondate) {
      setSnackbar({
        open: true,
        message: "Please fill in the session date",
        severity: "error",
      });
      return true;
    }
    if (!formData.sessiontype) {
      setSnackbar({
        open: true,
        message: "Please fill in the session type",
        severity: "error",
      });
      return true;
    } else if (!formData.facilityid) {
      setSnackbar({
        open: true,
        message: "Please fill in the facility name",
        severity: "error",
      });
      return true;
    } else if (!formData.clientid) {
      setSnackbar({
        open: true,
        message: "Please fill in the client name",
        severity: "error",
      });
      return true;
    } else if (!formData.staffid) {
      setSnackbar({
        open: true,
        message: "Please fill in the staff name",
        severity: "error",
      });
      return true;
    } else if (!formData.supervisorid) {
      setSnackbar({
        open: true,
        message: "Please fill in the supervisor name",
        severity: "error",
      });
      return true;
    } else if (!formData.parentorgurdianname) {
      setSnackbar({
        open: true,
        message: "Please fill in the parent or guardian name",
        severity: "error",
      });
      return true;
    } else if (!formData.placeofservicecode) {
      setSnackbar({
        open: true,
        message: "Please fill in the place of service",
        severity: "error",
      });
      return true;
    } else if (!formData.modifier) {
      setSnackbar({
        open: true,
        message: "Please fill in the modifier",
        severity: "error",
      });
      return true;
    } else if (!formData.procedurecode) {
      setSnackbar({
        open: true,
        message: "Please fill in the procedure code",
        severity: "error",
      });
      return true;
    } else if (!formData.diagnosiscode1) {
      setSnackbar({
        open: true,
        message: "Please fill in the diagnosis code",
        severity: "error",
      });
      return true;
    } else if (
      !formData.sessiontime ||
      !formData.sessiontime[0] ||
      !formData.sessiontime[1] === null
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the session time",
        severity: "error",
      });
      return true;
    } else if (
      formData.sessiontime[0].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[1].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[0].format("HH:mm:a") >
        formData.sessiontime[1].format("HH:mm:a")
    ) {
      setSnackbar({
        open: true,
        message: "Please fill session time correctly",
        severity: "error",
      });
      return true;
    } else if (formData.placeofservicecode === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the place of service",
        severity: "error",
      });
      return true;
    } else if (
      formData.placeofservicecode == "Other" &&
      formData.otherplaceofservice == ""
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the other place of service",
        severity: "error",
      });
      return true;
    } else if (
      formData.diagnosiscode1 == "Other" &&
      formData.otherdiagnosiscode == ""
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the other diagnosis code",
        severity: "error",
      });
      return true;
    } else if (formData.modifier === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the modifier",
        severity: "error",
      });
      return true;
    } else if (formData.procedurecode === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the procedure code",
        severity: "error",
      });
      return true;
    } else if (formData.diagnosiscode1 === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the diagnosis code",
        severity: "error",
      });
      return true;
    } else if (formData.sessionsummary === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the session summary",
        severity: "error",
      });
      return true;
    } else if (formData.reinforcerusedduringsession === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the reinforcer used during session",
        severity: "error",
      });
      return true;
    } else if (formData.primarytargetareasaddressed === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the primary target areas addressed",
        severity: "error",
      });
      return true;
    } else if (formData.maladaptivebehaviors === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the maladaptive behaviors",
        severity: "error",
      });
      return true;
    } else if (formData.clientmoodresponse === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the client mood response",
        severity: "error",
      });
      return true;
    } else if (formData.planfornextvisit === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the plan for next visit",
        severity: "error",
      });
      return true;
    }
    if (
      canApprove &&
      sigSupervisor.current &&
      !sigSupervisor.current.isEmpty() &&
      (!formData.supervisorsignaturedate ||
        formData.supervisorsignaturedate === null)
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the supervisor signature date",
        severity: "error",
      });
      return true;
    }

    return false;
  };
  const checkRequiredFieldForDraft = (formData) => {
    if (!formData.sessiondate) {
      setSnackbar({
        open: true,
        message: "Please fill in the session date",
        severity: "error",
      });
      return true;
    } else if (
      !formData.sessiontime ||
      !formData.sessiontime[0] ||
      !formData.sessiontime[1] === null
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the session time",
        severity: "error",
      });
      return true;
    } else if (
      formData.sessiontime[0].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[1].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[0].format("HH:mm:a") >
        formData.sessiontime[1].format("HH:mm:a")
    ) {
      setSnackbar({
        open: true,
        message: "Please fill session time correctly",
        severity: "error",
      });
      return true;
    } else if (!formData.facilityid) {
      setSnackbar({
        open: true,
        message: "Please fill in the facility name",
        severity: "error",
      });
      return true;
    } else if (!formData.clientid) {
      setSnackbar({
        open: true,
        message: "Please fill in the client name",
        severity: "error",
      });
      return true;
    } else if (!formData.staffid) {
      setSnackbar({
        open: true,
        message: "Please fill in the staff name",
        severity: "error",
      });
      return true;
    } else if (!formData.supervisorid) {
      setSnackbar({
        open: true,
        message: "Please fill in the supervisor name",
        severity: "error",
      });
      return true;
    }
    return false;
  };
  const handleSaveAsDraft = (formData, { resetForm }) => {
    if (checkRequiredFieldForDraft(formData)) {
      return;
    }
    let payload = handleData(formData);
    if (payload === null) {
      return;
    }
    console.log(payload, "sent");
    // console.log(values);
    openSnackbar("Saving...", "info");
    payload.sessionstatus = "Draft";
    console.log(payload);
    try {
      axiosInstance
        .post(getEndPoint(payload), {
          ...payload,
          staffid: payload.staffid.id,
          supervisorid: payload.supervisorid.id,
          facilityid: payload.facilityid.id,
          clientid: payload.clientid.id,
        })

        .then((res) => {
          if (res.status === 200) {
            resetOtherValues(formData, payload, resetForm);
            openSnackbar("Saved Successfully", "success");
          }
        })
        .catch((error) => {
          openSnackbar(error, "error");
          console.error("An error occurred:", error);
        });
    } catch (error) {
      setSnackbar(error, "error");
    }

    // Add your logic for saving as draft
  };

  const handleSaveAsReview = (formData, { resetForm }) => {
    if (handleErrors(formData)) {
      return;
    }

    if (
      (!formData.parentorgurdiansignaturefilename &&
        sigParent.current?.isEmpty()) ||
      (!formData.staffsignaturefilename && sigStaff.current?.isEmpty())
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the parent and staff signature",
        severity: "error",
      });
      return;
    }

    let payload = handleData(formData);
    if (payload === null) {
      return;
    }

    openSnackbar("Saving...", "info");
    console.log(payload, "sent");

    try {
      axiosInstance
        .post(getEndPoint(payload), {
          ...payload,
          staffid: payload.staffid.id,
          supervisorid: payload.supervisorid.id,
          facilityid: payload.facilityid.id,
          clientid: payload.clientid.id,

          sessionstatus: "Pending Review",
        })

        .then((res) => {
          if (res.status === 200) {
            openSnackbar("Saved Successfully", "success");
            resetOtherValues(
              formData,
              {
                ...payload,

                sessionstatus: "Pending Review",
              },
              resetForm
            );
          }
        })
        .catch((error) => {
          openSnackbar(error, "error");
          console.error("An error occurred:", error);
        });
    } catch (error) {
      openSnackbar(error, "error");
    }

    console.log("values sent");
  };

  const handleApprove = (formData, { resetForm }) => {
    if (handleErrors(formData)) {
      return;
    }
    const payload = handleData(formData);
    if (payload === null) {
      return;
    }
    if (
      (!formData.parentorgurdiansignaturefilename &&
        sigParent.current?.isEmpty()) ||
      (!formData.staffsignaturefilename && sigStaff.current?.isEmpty()) ||
      (canApprove &&
        !formData.supervisorsignaturefilename &&
        sigSupervisor.current?.isEmpty())
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the parent, staff and supervisor signature",
        severity: "error",
      });
      return;
    }

    let current = {
      ...payload,

      sessionstatus: "Approved",
    };
    openSnackbar("Saving...", "info");

    console.log(current, "sent");
    // console.log(values);
    try {
      axiosInstance
        .post(getEndPoint(current), {
          ...current,
          staffid: current.staffid.id,
          supervisorid: current.supervisorid.id,
          facilityid: current.facilityid.id,
          clientid: current.clientid.id,
        })
        .then((res) => {
          console.log(res.data, " ");
          if (res.status === 200) {
            console.log("Success");
            resetOtherValues(formData, current, resetForm);
            openSnackbar("Saved Successfully", "success");
          }
        })
        .catch((error) => {
          openSnackbar(error, "error");
          console.error("An error occurred:", error);
        });
    } catch (error) {
      openSnackbar(error, "error");
    }

    console.log("values sent");

    // Add your logic for approving
  };
  const resetOtherValues = async (values, payload, resetForm) => {
    console.log(payload, "in reset");
    if (mode == UPDATE) {
      setSupervisorSignatureImage({
        image: payload.supervisorsignaturefilename,
        exists: payload.supervisorsignatureexist,
        date: payload.supervisorsignaturedate,
      });
      setStaffSignatureImage({
        image: payload.staffsignaturefilename,
        exists: payload.staffsignatureexist,
        date: payload.staffsignaturedate,
      });
      setParentSignatureImage({
        image: payload.parentorgurdiansignaturefilename,
        exists: payload.parentorguardiansignatureexist,
        date: payload.parentorgurdiansignaturedate,
      });
      latestFormValues.current = {
        ...latestFormValues.current,
        parentorgurdiansignaturefilename:
          payload.parentorgurdiansignaturefilename,
        supervisorsignaturefilename: payload.supervisorsignaturefilename,
        supervisorsignaturedate: payload.supervisorsignaturedate,
        supervisorsignatureexist: payload.supervisorsignatureexist,
        staffsignaturefilename: payload.staffsignaturefilename,
        staffsignaturedate: payload.staffsignaturedate,
        staffsignatureexist: payload.staffsignatureexist,
        parentorgurdiansignaturedate: payload.parentorgurdiansignaturedate,
        parentorguardiansignatureexist: payload.parentSignatureExist,
        sessionstatus: payload.sessionstatus,
      };
      await localStorage.setItem(
        "lastSavedData",
        JSON.stringify({
          ...latestFormValues.current,
          parentorgurdiansignaturefilename:
            payload.parentorgurdiansignaturefilename,
          supervisorsignaturefilename: payload.supervisorsignaturefilename,
          supervisorsignaturedate: payload.supervisorsignaturedate,
          supervisorsignatureexist: payload.supervisorsignatureexist,
          staffsignaturefilename: payload.staffsignaturefilename,
          staffsignaturedate: payload.staffsignaturedate,
          staffsignatureexist: payload.staffsignatureexist,
          parentorgurdiansignaturedate: payload.parentorgurdiansignaturedate,
          parentorguardiansignatureexist: payload.parentSignatureExist,
          sessionstatus: payload.sessionstatus,
        })
      );
      console.log(
        "sign",
        supervisorSignatureImage,
        " ",
        parentSignatureImage,
        " ",
        staffSignatureImage
      );
    }
    if (sigParent.current) clearParentSignature();
    if (sigStaff.current) clearStaffSignature();
    if (canApprove && sigSupervisor.current) clearSupervisorSignature();
    if (mode !== UPDATE) {
      resetForm();
      values.clientid = "";

      setRbtWorkStyle({
        optiona: false,
        optionb: false,
        otherrbt: false,
      });
      setSessionParticipants({
        child: false,
        parent: false,
        bcba: false,
        behaviourtechnician: false,
        other: false,
      });
      setSkillStratergies({
        roleplaying: false,
        discretetrialtraining: false,
        behaviourmomentum: false,
        generalizationtraining: false,
        shapingchaining: false,
        naturalenvironmentteaching: false,
        providingsupport: false,
        na: false,
        otherskill: false,
      });
      setBehaviorStratergies({
        modeling: false,
        guidedcompliance: false,
        differntialreinforcement: false,
        verbalremindersprovided: false,
        firststatements: false,
        contigentrewards: false,
        visualsupports: false,
        nabehavior: false,
        otherbehavior: false,
      });

      latestFormValues.current = {}; // Clear form data
      setIsFormDirty(false);
      localStorage.removeItem(SESSION_ID);
      localStorage.removeItem("lastSavedData");
    }
  };
  const fetchEligibleSupervisors = async (id) => {
    try {
      const approval = await checkApprover(id);
      console.log("app", approval);
      setCanApprove(approval);
      const supervisorData = await fetchSupervisor(id);
      console.log("Fetched Supervisors:", supervisorData);
      setSelectedSupervisors(supervisorData);
    } catch (error) {
      console.error("Error checking approver:", error);
      setCanApprove(false);
      setSelectedSupervisors([]);
    }
  };

  useAutoSave(
    latestFormValues.current,
    "/api/addsessionnote",
    "/api/updatesessionnote",
    SESSION_ID
  );
  const handleFormSubmit = (values) => {};
  if (isloading) {
    return <LoadingIndicator />;
  } else {
    return (
      <Box m="20px">
        <Dialog
          open={showLeaveAlert}
          onClose={() => setShowLeaveAlert(false)}
          aria-labelledby="unsaved-changes-dialog">
          <DialogTitle id="unsaved-changes-dialog">Unsaved Changes</DialogTitle>
          <DialogContent>
            Are you sure want to leave? Unsaved changes will be lost.
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleLeaveAlertResponse(false)}
              color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => handleLeaveAlertResponse(true)}
              color="secondary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}>
            {snackbar.message}
          </Alert>
        </Snackbar>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <Header
            title=" Session Note (97153) "
            subtitle=""
            style={{ flexGrow: 1, textAlign: "center" }}
          />
          <br />
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body1" sx={{ marginRight: "10px" }}>
              Sample
            </Typography>
            <IconButton onClick={handleMenuOpen}>
              <VisibilityIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}>
              <MenuItem onClick={() => handleOpenModal("Sample 1.pdf")}>
                Sample 1
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal("Sample 2.pdf")}>
                Sample 2
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal("Sample 3.pdf")}>
                Sample 3
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal("Sample 4.pdf")}>
                Sample 4
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal("Sample 5.pdf")}>
                Sample 5
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal("Sample 6.pdf")}>
                Sample 6
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal("Sample 7.pdf")}>
                Sample 7
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal("Sample 8.pdf")}>
                Sample 8
              </MenuItem>
              {/* <MenuItem onClick={() => handleOpenModal("Sample 9.pdf")}>
                Sample 9
              </MenuItem> */}
              {/* <MenuItem onClick={() => handleOpenModal("Sample 10.pdf")}>
                Sample 10
              </MenuItem> */}
            </Menu>
            <SampleModal
              open={isModalOpen}
              handleClose={() => setIsModalOpen(false)}
              pdfUrl={selectedPdf}
            />
          </div>
        </Box>
        <Formik
          enableReinitialize
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}>
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            resetForm,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}>
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      fullWidth
                      options={facilities}
                      getOptionLabel={(option) => `${option.facilityName}`}
                      value={values.facilityid}
                      autoHighlight
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Facility Name"
                          variant="filled"
                          className="animated-input"
                          inputProps={{
                            ...params.inputProps,
                            "aria-label": "Select Facility",
                          }}
                        />
                      )}
                      onChange={(event, newValue) => {
                        handleFieldChange(
                          newValue ? newValue.id : "",
                          "facilityid",
                          initialValues
                        );
                        setFieldValue("facilityid", newValue ? newValue : "");
                      }}
                      disabled={fetchDisabling(values)}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    />
                  </FormControl>

                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      options={clients}
                      getOptionLabel={(option) =>
                        `${option.firstName} ${option.lastName} `
                      }
                      autoHighlight
                      value={values.clientid}
                      // disabled={from === "data collection"}
                      onChange={(event, newValue) => {
                        handleFieldChange(
                          newValue ? newValue.id : "",
                          "clientid",
                          initialValues
                        );
                        setFieldValue("clientid", newValue ? newValue : "");
                        setFieldValue(
                          "insurancename",
                          newValue ? newValue.insuranceName : ""
                        );
                        handleFieldChange(
                          newValue ? newValue.insuranceName : "",
                          "insurancename",
                          initialValues
                        );
                        setFieldValue(
                          "insurancepolicynumber",
                          newValue ? newValue.policyNumber : ""
                        );
                        handleFieldChange(
                          newValue ? newValue.policyNumber : "",
                          "insurancepolicynumber",
                          initialValues
                        );
                      }}
                      disabled={fetchDisabling(values)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Client Name"
                          variant="filled"
                          className="animated-input"
                          required
                          // disabled={from === "data collection"}
                        />
                      )}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    />
                  </FormControl>

                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      fullWidth
                      options={staffs}
                      disabled={fetchDisabling(values)}
                      getOptionLabel={(option) =>
                        `${option.firstName} ${option.lastName} `
                      }
                      value={values.staffid}
                      autoHighlight
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Staff Name"
                          variant="filled"
                          required
                          className="animated-input"
                          inputProps={{
                            ...params.inputProps,
                            "aria-label": "Select Staff Name",
                          }}
                        />
                      )}
                      onChange={async (event, newValue) => {
                        // Handle the change
                        if (newValue) {
                          fetchEligibleSupervisors(newValue.id);
                        } else {
                          setCanApprove(false);
                        }

                        setFieldValue("staffid", newValue ? newValue : "");
                        handleFieldChange(
                          newValue ? newValue.id : "",
                          "staffid",
                          initialValues
                        );
                      }}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    />
                  </FormControl>

                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      options={selectedSupervisors || []}
                      getOptionLabel={(option) => {
                        console.log("Option object:", option); // Log the option object to see its structure
                        return (
                          ` ${option.firstName} ${option.lastName}` +
                          (option.role ? ` ( ${option.role}) ` : "")
                        );
                      }}
                      autoHighlight
                      // value={
                      //   (supervisor || []).find((supervisor) => {
                      //     console.log(supervisor.id, " ", values.supervisorid);
                      //     return supervisor.id == values.supervisorid;
                      //   }) || null
                      // }
                      value={values.supervisorid}
                      onChange={(event, newValue) => {
                        handleFieldChange(
                          newValue ? newValue.id : "",
                          "supervisorid",
                          initialValues
                        );
                        console.log(newValue, "new value", selectedSupervisors);
                        setFieldValue("supervisorid", newValue ? newValue : "");
                      }}
                      disabled={fetchDisabling(values)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Supervisor Name"
                          variant="filled"
                          className="animated-input"
                          required
                        />
                      )}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    />
                  </FormControl>

                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    label="Insurance Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled
                    InputLabelProps={{ shrink: true }}
                    value={values.insurancename}
                    name="insurancename"
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    label="Insurance Policy Number"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    disabled
                    value={values.insurancepolicynumber}
                    name="insurancepolicynumber"
                    error={
                      !!touched.insurancepolicynumber &&
                      !!errors.insurancepolicynumber
                    }
                    helperText={
                      touched.insurancepolicynumber &&
                      errors.insurancepolicynumber
                    }
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                  <Autocomplete
                    fullWidth
                    autoHighlight
                    options={parentOrGurdian} // Array of parent or guardian names
                    getOptionLabel={(option) => option} // Assuming each option has a 'name' property
                    value={values.parentorgurdianname || ""}
                    onChange={(event, newValue) => {
                      handleFieldChange(
                        newValue ? newValue.id : "",
                        "parentorgurdianname",
                        initialValues
                      );
                      setFieldValue(
                        "parentorgurdianname",
                        newValue ? newValue : ""
                      );
                    }}
                    disabled={fetchDisabling(values)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Parent or Guardian"
                        variant="filled"
                        className="animated-input"
                        required
                      />
                    )}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      fullWidth
                      options={sessionType}
                      getOptionLabel={(option) => option} // Since options are strings
                      autoHighlight
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Session Type"
                          variant="filled"
                          className="animated-input"
                          required
                          inputProps={{
                            ...params.inputProps,
                            "aria-label": "Select Session Type",
                          }}
                        />
                      )}
                      value={values.sessiontype || null} // Fallback to null if no value is set
                      onChange={(event, newValue) => {
                        handleFieldChange(
                          newValue,
                          "sessiontype",
                          initialValues
                        );
                        setFieldValue("sessiontype", newValue);
                      }}
                      disabled={fetchDisabling(values)}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    />
                  </FormControl>
                  <DatePicker
                    fullWidth
                    label="Session Date"
                    variant="filled"
                    value={values.sessiondate || dayjs()}
                    onChange={(value) => {
                      handleFieldChange(
                        dayjs(value).format("YYYY-MM-DD"),
                        "sessiondate",
                        initialValues
                      );
                      setFieldValue("sessiondate", value); // Update the Formik field value
                    }}
                    name="sessiondate"
                    InputLabelProps={{ shrink: true }}
                    disableFuture
                    disabled={from === "data collection" || isDisabled}
                    slotProps={{
                      textField: {
                        error:
                          touched.sessiondate && Boolean(errors.sessiondate),
                        helperText: touched.sessiondate && errors.sessiondate,
                        sx: { gridColumn: "span 2", ...themeStyles.textField },
                      },
                    }}
                  />

                  <MultiInputTimeRangeField
                    name="sessiontime"
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    fullWidth
                    value={values.sessiontime}
                    onChange={(newValue) => {
                      const bothTimesCleared = !newValue?.[0] && !newValue?.[1];

                      // Update the dirty state based on the condition
                      const isDirty =
                        !bothTimesCleared &&
                        ((newValue?.[0]?.format("HH:mm") || "") !==
                          (initialValues.sessiontime?.[0]?.format("HH:mm") ||
                            "") ||
                          (newValue?.[1]?.format("HH:mm") || "") !==
                            (initialValues.sessiontime?.[1]?.format("HH:mm") ||
                              ""));

                      setIsFormDirty(isDirty); // Update the dirty state

                      handleChange({
                        target: {
                          name: "sessiontime",
                          value: newValue,
                        },
                      });
                      handleFieldChange(
                        newValue?.[0]?.format("HH:mm") || "",
                        "sessionstarttime",
                        initialValues
                      );
                      handleFieldChange(
                        newValue?.[1]?.format("HH:mm") || "",
                        "sessionendtime",
                        initialValues
                      );
                    }}
                    disabled={fetchDisabling(values)}
                    slotProps={{
                      textField: ({ position }) => ({
                        label:
                          position === "start"
                            ? "Session start time"
                            : "Session end time",
                        required: true,
                      }),
                    }}
                  />

                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      fullWidth
                      options={placeOfService} // Assuming 'placeOfService' is the array of options
                      autoHighlight
                      getOptionLabel={(option) => option.toString()} // Assuming 'option' is a string or object that can be converted to string
                      value={values.placeofservicecode}
                      onChange={(event, newValue) => {
                        handleFieldChange(
                          newValue || "",
                          "placeofservicecode",
                          initialValues
                        );
                        // Create a synthetic event to pass to handleChange
                        handleChange({
                          target: {
                            name: "placeofservicecode",
                            value: newValue || "", // Use an empty string if newValue is null
                          },
                        });
                      }}
                      disabled={fetchDisabling(values)}
                      onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Place of service"
                          variant="filled"
                          className="animated-input"
                          required
                          inputProps={{
                            ...params.inputProps,
                            "aria-label": "Select a place of service",
                          }}
                        />
                      )}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    />
                  </FormControl>

                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    label="Other Place of Service (Maxlength: 30)"
                    onBlur={handleBlur}
                    onChange={(event) =>
                      handleInputChange(event, setFieldValue)
                    }
                    required={values.placeofservicecode === "Other"}
                    value={values.otherplaceofservice}
                    name="otherplaceofservice"
                    disabled={
                      isDisabled || values.placeofservicecode !== "Other"
                    }
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    inputProps={{
                      maxLength: 30,
                    }}
                  />
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      fullWidth
                      options={moDifier} // Assuming 'moDifier' is the array of options
                      autoHighlight
                      getOptionLabel={(option) => option} // Assuming 'option' is a string you want to display
                      value={values.modifier || ""} // Fallback to an empty string if values.modifier is undefined
                      onChange={(event, newValue) => {
                        handleFieldChange(
                          newValue || "",
                          "modifier",
                          initialValues
                        );
                        // Create a synthetic event to pass to handleChange
                        handleChange({
                          target: {
                            name: "modifier",
                            value: newValue || "", // Use an empty string if newValue is null
                          },
                        });
                      }}
                      disabled={fetchDisabling(values)}
                      onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Modifier"
                          variant="filled"
                          className="animated-input"
                          required
                          inputProps={{
                            ...params.inputProps,
                            "aria-label": "Select a modifier",
                          }}
                        />
                      )}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                      renderOption={(props, option) => (
                        <MenuItem {...props} key={option} value={option}>
                          {option}
                        </MenuItem>
                      )}
                    />
                  </FormControl>
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      fullWidth
                      options={procedureCode} // Assuming 'procedureCode' is the array of options
                      autoHighlight
                      getOptionLabel={(option) => option} // Assuming 'option' is a string you want to display
                      value={values.procedurecode || ""} // Fallback to an empty string if values.procedurecode is undefined
                      onChange={(event, newValue) => {
                        // Create a synthetic event to pass to handleChange
                        handleChange({
                          target: {
                            name: "procedurecode",
                            value: newValue || null, // Use an empty string if newValue is null
                          },
                        });
                      }}
                      onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Procedure Code"
                          variant="filled"
                          className="animated-input"
                          required
                          inputProps={{
                            ...params.inputProps,
                            "aria-label": "Select a procedure code",
                          }}
                        />
                      )}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                      disabled={true}
                      renderOption={(props, option) => (
                        <MenuItem {...props} key={option} value={option}>
                          {option}
                        </MenuItem>
                      )}
                    />
                  </FormControl>

                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <Autocomplete
                      fullWidth
                      options={diagnosisCode} // Assuming 'diagnosisCode' is the array of options
                      autoHighlight
                      getOptionLabel={(option) => option} // Assuming 'option' is a string you want to display
                      value={values.diagnosiscode1 || ""} // Fallback to an empty string if values.diagnosiscode1 is undefined
                      onChange={(event, newValue) => {
                        // Create a synthetic event to pass to handleChange
                        handleChange({
                          target: {
                            name: "diagnosiscode1",
                            value: newValue || "", // Use an empty string if newValue is null
                          },
                        });
                        handleFieldChange(
                          newValue || "",
                          "diagnosiscode1",
                          values
                        );
                      }}
                      disabled={fetchDisabling(values)}
                      onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Diagnosis Code 1"
                          variant="filled"
                          className="animated-input"
                          required
                          inputProps={{
                            ...params.inputProps,
                            "aria-label": "Select a diagnosis code",
                          }}
                        />
                      )}
                      sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                      // disabled={localStorage.getItem("role") === "Staff"}
                    />
                  </FormControl>

                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    label="Other Diagnosis Code (Maxlength: 30)"
                    onBlur={handleBlur}
                    onChange={(event) =>
                      handleInputChange(event, setFieldValue)
                    }
                    name="otherdiagnosiscode"
                    required={values.diagnosiscode1 === "Other"}
                    disabled={isDisabled || values.diagnosiscode1 !== "Other"}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    inputProps={{
                      maxLength: 30,
                    }}
                  />

                  <FormGroup
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Session Participant
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={child}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSessionParticipants,
                              "sessionparticipants",
                              SESSION_PARTICIPANTS_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="child"
                        />
                      }
                      label="Child"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={parent}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSessionParticipants,
                              "sessionparticipants",
                              SESSION_PARTICIPANTS_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="parent"
                        />
                      }
                      label="Parent"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={bcba}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSessionParticipants,
                              "sessionparticipants",
                              SESSION_PARTICIPANTS_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="bcba"
                        />
                      }
                      label="BCBA"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={behaviourtechnician}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSessionParticipants,
                              "sessionparticipants",
                              SESSION_PARTICIPANTS_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="behaviourtechnician"
                        />
                      }
                      label="Behaviour Technician"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={other}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSessionParticipants,
                              "sessionparticipants",
                              SESSION_PARTICIPANTS_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="other"
                        />
                      }
                      label="Other"
                    />
                    {other && (
                      <TextareaAutosize
                        fullWidth
                        variant="filled"
                        className="animated-input"
                        placeholder="Type in here… (Maxlength: 30)"
                        name="othersessionparticipants"
                        value={values.othersessionparticipants}
                        onChange={(event, newValue) => {
                          // Create a synthetic event to pass to handleChange
                          setFieldValue(
                            "othersessionparticipants",
                            event.target.value
                          );
                          handleFieldChange(
                            event.target.value || "",
                            "othersessionparticipants",
                            values
                          );
                        }}
                        disabled={fetchDisabling(values)}
                        minRows={2}
                        maxRows={2}
                        required={other}
                        inputProps={{
                          maxLength: 30,
                        }}
                      />
                    )}
                  </FormGroup>
                  <FormGroup
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <FormLabel component="legend">Work Style</FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={optiona}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setRbtWorkStyle,
                              "rbtworkstyle",
                              RBT_WORK_STYLE_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="optiona"
                        />
                      }
                      label="RBT/BT worked on goals in the treatment plan"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={optionb}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setRbtWorkStyle,
                              "rbtworkstyle",
                              RBT_WORK_STYLE_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="optionb"
                        />
                      }
                      label="RBT/BT worked on
                  pairing self with reinforcers"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={otherrbt}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setRbtWorkStyle,
                              "rbtworkstyle",
                              RBT_WORK_STYLE_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="otherrbt"
                        />
                      }
                      label="Other"
                    />
                    {otherrbt && (
                      <TextareaAutosize
                        fullWidth
                        variant="filled"
                        className="animated-input"
                        placeholder="Type in here… (Maxlength: 30)"
                        name="otherrbtworkstyle"
                        value={values.otherrbtworkstyle}
                        onChange={(event, newValue) => {
                          // Create a synthetic event to pass to handleChange
                          setFieldValue(
                            "otherrbtworkstyle",
                            event.target.value
                          );

                          handleFieldChange(
                            event.target.value || "",
                            "otherrbtworkstyle",
                            values
                          );
                        }}
                        disabled={fetchDisabling(values)}
                        minRows={2}
                        maxRows={3}
                        required={otherrbt}
                        inputProps={{
                          maxLength: 30,
                        }}
                      />
                    )}
                  </FormGroup>
                  <FormGroup
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <FormLabel component="legend">Skill Stratergies</FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={roleplaying}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="roleplaying"
                        />
                      }
                      label="Role playing or modeling 
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={discretetrialtraining}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="discretetrialtraining"
                        />
                      }
                      label="Discrete trial training 
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={behaviourmomentum}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="behaviourmomentum"
                        />
                      }
                      label="Behaviour momentum
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={generalizationtraining}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="generalizationtraining"
                        />
                      }
                      label="Gereralization training 
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={shapingchaining}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="shapingchaining"
                        />
                      }
                      label="Shaping/Chaining"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={naturalenvironmentteaching}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="naturalenvironmentteaching"
                        />
                      }
                      label="Natural environment teaching
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={providingsupport}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            ); // Update the st  handleFieldChange(); // Mark form as dirty
                          }}
                          disabled={fetchDisabling(values)}
                          name="providingsupport"
                        />
                      }
                      label="Providing support with prompt fading
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={na}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="na"
                        />
                      }
                      label="N/A
                  "
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={otherskill}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setSkillStratergies,
                              "skillstrategiesapplied",
                              SKILL_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="otherskill"
                        />
                      }
                      label="Others"
                    />
                    {otherskill && (
                      <TextareaAutosize
                        fullWidth
                        variant="filled"
                        className="animated-input"
                        placeholder="Type in here… (Maxlength: 30)"
                        name="otherskillstrategiesapplied"
                        value={values.otherskillstrategiesapplied}
                        onChange={(event, newValue) => {
                          setFieldValue(
                            "otherskillstrategiesapplied",
                            event.target.value
                          );
                          handleFieldChange(
                            event.target.value || "",
                            "otherskillstrategiesapplied",
                            values
                          );
                        }}
                        disabled={fetchDisabling(values)}
                        minRows={2}
                        maxRows={4}
                        required={otherskill}
                        inputProps={{
                          maxLength: 30,
                        }}
                      />
                    )}
                  </FormGroup>
                  <FormGroup
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Behavioral Stratergies
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={modeling}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="modeling"
                        />
                      }
                      label="Modeling
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={guidedcompliance}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="guidedcompliance"
                        />
                      }
                      label="Guided Compliance 
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={differntialreinforcement}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="differntialreinforcement"
                        />
                      }
                      label="Differential Reinforcement 
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={verbalremindersprovided}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="verbalremindersprovided"
                        />
                      }
                      label="Verbal reminders provided 
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={firststatements}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            );
                          }}
                          disabled={fetchDisabling(values)}
                          name="firststatements"
                        />
                      }
                      label="First/Then statements
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={contigentrewards}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            ); // Update state
                          }}
                          disabled={fetchDisabling(values)}
                          name="contigentrewards"
                        />
                      }
                      label="Contingent rewards/reinforcer
                  "
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={visualsupports}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            ); // Update state
                          }}
                          disabled={fetchDisabling(values)}
                          name="visualsupports"
                        />
                      }
                      label="Visual supports (timer, schedule, 
                    token board etc.)"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={nabehavior}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            ); // Update state
                          }}
                          disabled={fetchDisabling(values)}
                          name="nabehavior"
                        />
                      }
                      label="N/A"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={otherbehavior}
                          onChange={(event) => {
                            updateCheckboxState(
                              event,
                              setBehaviorStratergies,
                              "behaviorstrategiesapplied",
                              BEHAVIOR_STRATEGIES_MAPPING
                            ); // Update state
                          }}
                          disabled={fetchDisabling(values)}
                          name="otherbehavior"
                        />
                      }
                      label="Others"
                    />
                    {otherbehavior && (
                      <TextareaAutosize
                        fullWidth
                        variant="filled"
                        className="animated-input"
                        placeholder="Type in here… (Maxlength: 30)"
                        name="otherbehaviorstrategiesapplied"
                        value={values.otherbehaviorstrategiesapplied}
                        onChange={(event, newValue) => {
                          // Create a synthetic event to pass to handleChange
                          setFieldValue(
                            "otherbehaviorstrategiesapplied",
                            event.target.value
                          );
                          handleFieldChange(
                            event.target.value || "",
                            "otherbehaviorstrategiesapplied",
                            values
                          );
                        }}
                        disabled={fetchDisabling(values)}
                        minRows={2}
                        maxRows={4}
                        required={otherbehavior}
                        inputProps={{
                          maxLength: 30,
                        }}
                      />
                    )}
                  </FormGroup>
                  <FormGroup
                    fullWidth
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Reinforcers Used (Maxlength: 1000)
                      <Tooltip title="Help">
                        <IconButton
                          onClick={() =>
                            handleImageModal("reinforcersused.jpeg")
                          }>
                          <HelpOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </FormLabel>
                    <Dialog
                      open={isImageModalOpen}
                      onClose={handleCloseImageModal}
                      maxWidth="sm">
                      <DialogContent>
                        {/* Close button */}
                        <IconButton
                          aria-label="close"
                          onClick={handleCloseImageModal}
                          style={{ position: "absolute", right: 8, top: 8 }}>
                          <CloseIcon />
                        </IconButton>

                        {/* Image content */}
                        <img
                          src={selectedPdf}
                          alt="Popup Content"
                          style={{ width: "100%" }}
                        />
                      </DialogContent>
                    </Dialog>

                    <TextField
                      fullWidth
                      required
                      variant="filled"
                      className="animated-input"
                      onBlur={handleBlur}
                      onChange={(event) => {
                        handleInputChange(event, setFieldValue); // Update Formik's state
                      }}
                      disabled={fetchDisabling(values)}
                      value={values.reinforcerusedduringsession}
                      name="reinforcerusedduringsession"
                      // sx={{ gridColumn: "span 4",...themeStyles.textField }}
                      rows={5}
                      inputProps={{ maxLength: 1000 }}
                      multiline
                    />
                  </FormGroup>
                  <FormGroup
                    fullWidth
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Primary Target Areas Addressed (Maxlength: 1000)
                      <Tooltip title="Help">
                        <IconButton
                          onClick={() =>
                            handleImageModal("primarytargetareasaddressed.png")
                          }>
                          <HelpOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      onBlur={handleBlur}
                      onChange={(event) => {
                        handleInputChange(event, setFieldValue); // Update Formik's state
                        // Mark the form as dirty handleFieldChange();
                      }}
                      disabled={fetchDisabling(values)}
                      required
                      value={values.primarytargetareasaddressed}
                      name="primarytargetareasaddressed"
                      multiline
                      inputProps={{ maxLength: 1000 }}
                      sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                      rows={5}
                    />
                  </FormGroup>
                  <FormGroup
                    fullWidth
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Describe Maladaptive Behaviour (Maxlength: 1000)
                      <Tooltip title="Help">
                        <IconButton>
                          <HelpOutlineIcon
                            onClick={() =>
                              handleImageModal("maladaptivebehaviors.jpeg")
                            }
                          />
                        </IconButton>
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      onBlur={handleBlur}
                      onChange={(event) => {
                        handleInputChange(event, setFieldValue); // Update Formik's state
                      }}
                      disabled={fetchDisabling(values)}
                      required
                      value={values.maladaptivebehaviors}
                      name="maladaptivebehaviors"
                      sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                      rows={5}
                      multiline
                      inputProps={{ maxLength: 1000 }}
                      // inputProps={{ maxLength: 50 }}
                    />
                  </FormGroup>
                  <FormGroup
                    fullWidth
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Session Summary (Maxlength: 2500)
                      <Tooltip title="Help">
                        <IconButton
                          onClick={() =>
                            handleImageModal("sessionsummary.png")
                          }>
                          <HelpOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      onBlur={handleBlur}
                      onChange={(event) => {
                        handleInputChange(event, setFieldValue); // Update Formik's state
                      }}
                      disabled={fetchDisabling(values)}
                      value={values.sessionsummary}
                      name="sessionsummary"
                      sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                      rows={5}
                      multiline
                      inputProps={{ maxLength: 2500 }}
                      required
                    />
                  </FormGroup>
                  <FormGroup
                    fullWidth
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Client Mood Response (Maxlength: 1000)
                      <Tooltip title="Help">
                        <IconButton
                          onClick={() =>
                            handleImageModal("clientmoodresponse.jpeg")
                          }>
                          <HelpOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      onBlur={handleBlur}
                      onChange={(event) => {
                        handleInputChange(event, setFieldValue); // Update Formik's state
                      }}
                      disabled={fetchDisabling(values)}
                      value={values.clientmoodresponse}
                      required
                      name="clientmoodresponse"
                      sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                      rows={5}
                      multiline
                      inputProps={{ maxLength: 1000 }}
                    />
                  </FormGroup>
                  <FormGroup
                    fullWidth
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                    <FormLabel component="legend">
                      Plan for Next Visit (Maxlength: 1000)
                      <Tooltip title="Help">
                        <IconButton
                          onClick={() =>
                            handleImageModal("planfornextvisit.png")
                          }>
                          <HelpOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      onBlur={handleBlur}
                      onChange={(event) => {
                        handleInputChange(event, setFieldValue); // Update Formik's state
                      }}
                      disabled={fetchDisabling(values)}
                      value={values.planfornextvisit}
                      name="planfornextvisit"
                      sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                      rows={5}
                      inputProps={{ maxLength: 1000 }}
                      required
                      multiline
                    />
                  </FormGroup>
                  <FormGroup
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <FormLabel component="legend">Staff's signature</FormLabel>
                    {staffSignatureImage.image ? (
                      <Box display="flex" alignItems="center">
                        <img
                          src={staffSignatureImage.image}
                          alt="Staff  Signature"
                          height="100"
                          width="150"
                        />
                        {checkPermission(
                          SESSION_NOTE_97153,
                          DELETE,
                          checkOwner(values),
                          values.sessionstatus
                        ) && (
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteSignature("Staff")}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Box>
                    ) : (
                      !isDisabled && (
                        <>
                          <FormControlLabel
                            control={
                              <SignaturePad
                                ref={sigStaff}
                                onEnd={handleStaffSignature}
                                canvasProps={{
                                  height: 200,
                                  className: "sigCanvas",
                                  marginTop: "50px",
                                }}
                              />
                            }
                          />
                          <FormControlLabel
                            control={
                              <div>
                                <Button
                                  onClick={clearStaffSignature}
                                  // fullWidth
                                  //  fullWidth
                                  variant="contained"
                                  color="primary"
                                  margin="10px"
                                  sx={{
                                    gridColumn: "span 1",
                                    ...buttonStyle,
                                  }}>
                                  Clear
                                </Button>
                              </div>
                            }
                          />
                        </>
                      )
                    )}
                  </FormGroup>

                  <FormGroup
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                    <FormLabel component="legend">Parent's signature</FormLabel>
                    {parentSignatureImage.image ? (
                      <Box display="flex" alignItems="center">
                        <img
                          src={parentSignatureImage.image}
                          alt="Parent  Signature"
                          height="100"
                          width="150"
                        />{" "}
                        {checkPermission(
                          SESSION_NOTE_97153,
                          DELETE,
                          checkOwner(values),
                          values.sessionstatus
                        ) && (
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteSignature("Parent")}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Box>
                    ) : (
                      !isDisabled && (
                        <>
                          <FormControlLabel
                            control={
                              <SignaturePad
                                ref={sigParent}
                                onEnd={handleParentSignature}
                                canvasProps={{
                                  height: 200,
                                  className: "sigCanvas",
                                  marginTop: "50px",
                                }}
                              />
                            }
                          />
                          <FormControlLabel
                            control={
                              <div>
                                <Button
                                  onClick={clearParentSignature}
                                  // fullWidth
                                  //  fullWidth
                                  variant="contained"
                                  color="primary"
                                  margin="10px"
                                  sx={{
                                    gridColumn: "span 1",
                                    ...buttonStyle,
                                  }}>
                                  Clear
                                </Button>
                              </div>
                            }
                          />
                        </>
                      )
                    )}
                  </FormGroup>

                  {canApprove && (
                    <>
                      {console.log(
                        supervisorSignatureImage,
                        "supervisor sign "
                      )}
                      <FormGroup
                        sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                        <FormLabel component="legend">
                          supervisor's signature
                        </FormLabel>
                        {supervisorSignatureImage.image ? (
                          <Box display="flex" alignItems="center">
                            <img
                              src={supervisorSignatureImage.image}
                              alt="Supervisor Signature"
                              height="100"
                              width="150"
                            />

                            {checkPermission(
                              SESSION_NOTE_97153,
                              DELETE,
                              checkOwner(values),
                              values.sessionstatus
                            ) && (
                              <IconButton
                                color="error"
                                onClick={() =>
                                  handleDeleteSignature("Supervisor")
                                }>
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </Box>
                        ) : (
                          !isDisabled && (
                            <>
                              <FormControlLabel
                                control={
                                  <SignaturePad
                                    ref={sigSupervisor}
                                    onEnd={handleSupervisorSignature}
                                    canvasProps={{
                                      height: 200,
                                      className: "sigCanvas",
                                      marginTop: "50px",
                                    }}
                                  />
                                }
                              />
                              <FormControlLabel
                                control={
                                  <div>
                                    <Button
                                      onClick={clearSupervisorSignature}
                                      // fullWidth
                                      //  fullWidth
                                      variant="contained"
                                      color="primary"
                                      margin="10px"
                                      sx={{
                                        gridColumn: "span 1",
                                        ...buttonStyle,
                                      }}>
                                      Clear
                                    </Button>
                                  </div>
                                }
                              />
                            </>
                          )
                        )}
                      </FormGroup>
                      {!supervisorSignatureImage.image || !isDisabled ? (
                        <DatePicker
                          fullWidth
                          label="Supervisor Signature Date"
                          variant="filled"
                          value={
                            values.supervisorsignaturedate ||
                            supervisorSignatureImage.date ||
                            null
                          }
                          onChange={(value) =>
                            setFieldValue("supervisorsignaturedate", value)
                          }
                          name="supervisorsignaturedate"
                          InputLabelProps={{ shrink: true }}
                          disabled={!isSignaturePresent}
                          slotProps={{
                            textField: {
                              error:
                                touched.supervisorsignaturedate &&
                                Boolean(errors.supervisorsignaturedate),
                              helperText:
                                touched.supervisorsignaturedate &&
                                errors.supervisorsignaturedate,
                              required: !sigSupervisor?.current?.isEmpty(),
                              sx: {
                                gridColumn: "span 2",
                                ...themeStyles.textField,
                                marginTop: "50px",
                              },
                            },
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button
                    type="button"
                    color="secondary"
                    variant="contained"
                    sx={{ ...buttonStyle }}
                    style={{ marginRight: "10px" }}
                    onClick={handleGoBack}
                    // pass the values directly
                  >
                    Go Back
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    variant="contained"
                    sx={{ ...buttonStyle }}
                    style={{ marginRight: "10px" }}
                    disabled={fetchDisabling(values)}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default form submission
                      handleSaveAsDraft(values, { resetForm });
                    }} // pass the values directly
                  >
                    Save as draft
                  </Button>
                  <Button
                    type="button"
                    sx={{ ...buttonStyle }}
                    color="secondary"
                    disabled={fetchDisabling(values)}
                    variant="contained"
                    style={{ marginRight: "10px" }}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default form submission
                      handleSaveAsReview(values, { resetForm });
                    }} // pass the values directly
                  >
                    Save as review
                  </Button>
                  {canApprove && (
                    <Button
                      type="submit"
                      color="secondary"
                      sx={{ ...buttonStyle }}
                      disabled={fetchDisabling(values)}
                      variant="contained"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default form submission
                        handleApprove(values, { resetForm });
                      }} // pass the values directly // pass the values directly
                    >
                      Approve
                    </Button>
                  )}
                </Box>
              </form>
            );
          }}
        </Formik>
      </Box>
    );
  }
};

const checkoutSchema = yup.object().shape({});

export default SessionNote;
